import axiosHttp from "./interceptor";
import { emitToasterMsg } from "./toasterUtility";
import roundNumericValues from "../common/utils/RoundNumericValues";

export const getCIIdata = async (masterId) => {
	try {
		const response = await axiosHttp.get(`api/Cii?reportMstId=${masterId}`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const confirmManualCIIUpdate = async (
	reportMstId,
	manualUpdatedData
) => {
	try {
		const response = await axiosHttp.post(
			`api/Cii/GradeCalculator?reportMstId=${reportMstId}`,
			manualUpdatedData
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const fetchManualCII = async (reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/Cii/GetClientInput?reportMstId=${reportMstId}`
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const searchVesselWithIMoOptions = async (searchValue) => {
	try {
		const response = await axiosHttp.post(
			`api/MyFleet/SearchVesselDropDown`,
			searchValue
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const calculateCIIData = async (CIIFormData) => {
	try {
		const response = await axiosHttp.post(
			`api/Cii/CiiCalculator`,
			CIIFormData
		);
		return response?.data;
	} catch (error) {
		console.error(error);
	}
};

export const getFuelRegistry = async (vesselMstId) => {
    try {
        var url = vesselMstId && vesselMstId > 0 ? `api/FuelRegistry/vessel/${vesselMstId}` : `api/FuelRegistry/base`;
        const response = await axiosHttp.get(url);
        return roundNumericValues(response.data?.data || [], 3);
    } catch (error) {
        console.log("API ERROR:", error);
        return [];
    }
};


export const isVesselCapacityChanged = async (vesselMstId) => {
    try {
        const response = await axiosHttp.get(
            `api/MyFleet/IsVesselCapacityChanged?vesselMstId=${vesselMstId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error checking vessel capacity change:", error);
        return false;
    }
};
